import React from "react";
import { Link } from "react-scroll";
import { FaBug, FaCode, FaLayerGroup } from "react-icons/fa";

const badges = [
  { icon: <FaBug size={13} />, label: "QA Engineering" },
  { icon: <FaCode size={13} />, label: "Test Automation" },
  { icon: <FaLayerGroup size={13} />, label: "Product Thinking" },
];

const Home = () => {
  return (
    <section name="home" className="w-full min-h-screen flex items-center bg-[#2F4156]">
      <div className="max-w-5xl mx-auto px-6 py-32">
        <p className="fade-up delay-1 text-sm font-medium text-[#C8D9E6] tracking-widest uppercase mb-4">
          Available for opportunities
        </p>

        <h1 className="fade-up delay-2 text-5xl sm:text-7xl font-bold text-[#F5EFEB] leading-tight mb-6">
          Jasper Manalo
        </h1>

        <p className="fade-up delay-3 text-2xl sm:text-3xl font-medium text-[#C8D9E6] mb-8">
          QA Engineer
        </p>

        <p className="fade-up delay-3 text-base text-[#C8D9E6] max-w-xl leading-relaxed mb-8">
          I find what breaks before your users do. Specializing in manual and
          automated testing, API validation, and building quality into the
          product from day one.
        </p>

        {/* Icon badges */}
        <div className="fade-up delay-4 flex flex-wrap gap-3 mb-10">
          {badges.map(({ icon, label }) => (
            <span key={label}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#567C8D] text-[#C8D9E6] text-xs font-medium">
              {icon}
              {label}
            </span>
          ))}
        </div>

        <div className="fade-up delay-5 flex flex-wrap gap-4">
          <Link to="work" smooth duration={500}
            className="px-6 py-3 bg-[#F5EFEB] text-[#2F4156] text-sm font-medium rounded-md hover:bg-[#C8D9E6] transition-colors cursor-pointer">
            View Work
          </Link>
          <Link to="contact" smooth duration={500}
            className="px-6 py-3 border border-[#567C8D] text-[#F5EFEB] text-sm font-medium rounded-md hover:border-[#C8D9E6] transition-colors cursor-pointer">
            Get in Touch
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Home;
